import { http } from 'utils'

// Dashboard mutation imports.
import { SET_BI_DATA, SET_BI_METRICS, SET_BI_ANNUAL } from 'vx/mutations'

// Dashboard state.
const state = {
  data: {},
  metrics: {
    'invoices': {},
    'requests': {},
    'completed': {},
    'leads': {},
    'star_signups': {},
    'manager_signups': {},
    'client_signups': {}
  },
  annual: {}
}

// Dashboard state getters.
const getters = {}

// Dashboard actions.
const actions = {
  getData ({ commit }, params) {
    return http.get('business_intelligence', { params })
      .then((response) => {
        commit(SET_BI_DATA, response.data)

        return response
      })
  },

  getMetrics ({ commit }, params) {
    return http.get('business_intelligence/limited_metrics', { params })
      .then((response) => {
        commit(SET_BI_METRICS, response.data)

        return response
      })
  },

  getAnnual ({ commit }, params) {
    return http.get('business_intelligence/limited_annual', { params })
      .then((response) => {
        commit(SET_BI_ANNUAL, response.data)

        return response
      })
  }
}

// Dashboard state mutations.
const mutations = {
  [SET_BI_DATA] (state, data) {
    state.data = data
  },

  [SET_BI_METRICS] (state, metrics) {
    state.metrics = metrics
  },

  [SET_BI_ANNUAL] (state, metrics) {
    state.annual = metrics
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
